module.exports = __webpack_public_path__ + "img/GHS-pictogram-bottle.f2017b13.png";